// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';
import { TStabilityPresentation, TWeaponPresentation } from '../../types';

const reducers = {
  setSessionsData: (state: IRootState, action: PayloadAction<IRootState['sessions']>) => ({
    ...state,
    sessions: action.payload,
  }),
  setScenariosData: (state: IRootState, action: PayloadAction<IRootState['scenarios']>) => ({
    ...state,
    scenarios: [...state.scenarios, ...action.payload.filter(
      (rep) => !state.scenarios.some((s) => s.scenarioid === rep.scenarioid)
    )],
  }),
  setTransactionsData: (state: IRootState, action: PayloadAction<IRootState['transactions']>) => ({
    ...state,
    transactions: [...state.transactions, ...action.payload.filter(
      (rep) => !state.transactions.some((t) => t.session_id === rep.session_id)
    )],
  }),
  setRepetitionsData: (state: IRootState, action: PayloadAction<IRootState['repetitions']>) => ({
    ...state,
    repetitions: [...state.repetitions, ...action.payload.filter(
      (rep) => !state.repetitions.some((r) => r.scenarioId === rep.scenarioId)
    )],
  }),
  setWeaponPresentation: (state: IRootState, action: PayloadAction<TWeaponPresentation>) => {
    const incoming = action.payload;

    const alreadyExists = state.weapon_presentation.some(
      (wp) =>
        wp.sessionId === incoming.sessionId &&
        wp.scenarioId === incoming.scenarioId &&
        wp.userId === incoming.userId &&
        wp.drillName === incoming.drillName &&
        wp.repetitionNumber === incoming.repetitionNumber
    );

    if (!alreadyExists) {
      state.weapon_presentation.push(incoming);
    }
  },
  setStabilityPresentation: (state: IRootState, action: PayloadAction<TStabilityPresentation>) => {
    const incoming = action.payload;

    const alreadyExists = state.stability_presentation.some(
      (s) =>
        s.sessionId === incoming.sessionId &&
        s.scenarioId === incoming.scenarioId &&
        s.userId === incoming.userId &&
        s.drillName === incoming.drillName &&
        s.repetitionNumber === incoming.repetitionNumber
    );

    if (!alreadyExists) {
      state.stability_presentation.push(incoming);
    }
  },
  resetShootingData: () => initialState,
};

export { reducers };
